import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoalRelatedGoal } from '../../types';
import { GoalInlineLabels } from '../GoalInlineLabels';
import { useSelectedGoal } from '../../useSelectedGoal';
import { Link } from '../../../../../../../Router';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';
import './GoalAlignedTo.css';

const i18prefix = 'performanceReview.goals2.goalAlignedTo';

type Props = {
  goal: GoalRelatedGoal;
  currentGoalId: string;
  onRemove: () => void;
  onLinkClick?: () => void;
};

export const GoalAlignedToItem: React.FC<Props> = ({
  goal,
  currentGoalId,
  onRemove,
  onLinkClick,
}) => {
  const { t } = useTranslation();
  const { getGoalRouteById } = useSelectedGoal();
  const highlight = currentGoalId === goal.id;

  return (
    <div className="goal-aligned-to-item d-flex align-items-center gap-1 fs-5 text-nowrap">
      {highlight ? (
        <span className="text-truncate" title={goal.name}>
          {goal.name}
        </span>
      ) : (
        <Link
          className="text-truncate"
          title={goal.name}
          to={getGoalRouteById({ id: goal.id, type: goal.type })}
          onClick={onLinkClick}>
          {goal.name}
        </Link>
      )}
      <GoalInlineLabels
        goalType={goal.type}
        goalEmployee={goal.employee}
        goalTeam={goal.team}
      />
      <button
        type="button"
        className="btn btn-link p-0 ms-1 text-muted"
        onClick={onRemove}
        title={t(`${i18prefix}.removeAlignment`)}
        aria-label={t(`${i18prefix}.removeAlignment`)}>
        <FlairIcon icon="close-outline" className="mt-2" />
      </button>
    </div>
  );
};
